import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import routeConstants from '../utils/routeConstants';
import i18n from '../utils/i18n';
import Button from '../components/Button';
import { modals, subscriptionStatuses, MONTHS } from '../utils/constants';
import { openModal } from '../actions/modalsActions';
import { getUserData } from '../actions/userActions';
import { getNumberWithSuffix } from '../utils/other';
import './styles/PremiumCardContainer.scss';

class PremiumCardContainer extends React.Component {
  static formatSubscriptionEndDate(subscriptionEndDate) {
    const date = new Date(subscriptionEndDate);
    let dateText = MONTHS[date.getMonth()];
    dateText += ` ${getNumberWithSuffix(date.getDate())}`;
    return dateText;
  }

  constructor(props) {
    super(props);

    this.routeToPremiumScreen = this.routeTo.bind(
      this,
      routeConstants.DEUCE_PREMIUM_PAGE
    );
    this.routeToUpdateCardScreen = this.routeTo.bind(
      this,
      routeConstants.UPDATE_CARD_ROUTE
    );
    this.startSubscriptionCancel = this.startSubscriptionCancel.bind(this);
  }

  componentWillMount() {
    this.props.getUserData();
  }

  routeTo(route) {
    this.props.dispatch(push(route));
  }

  startSubscriptionCancel() {
    const { user } = this.props;
    const subscriptionEndDate = user && user.subscription_period_end;
    this.props.openModal(modals.CANCEL_PREMIUM_MODAL, {
      subscriptionEndDate: PremiumCardContainer.formatSubscriptionEndDate(
        subscriptionEndDate
      )
    });
  }

  render() {
    const { user } = this.props;
    const {
      NO_VALID_SUBSCRIPTION,
      TRIAL,
      ACTIVE,
      UNPAID,
      EXPIRING
    } = subscriptionStatuses;

    const userCanUpdateOrCancel =
      user && [TRIAL, ACTIVE, UNPAID].indexOf(user.subscription_status) !== -1;

    const userCanBuyPremium =
      user && user.subscription_status === NO_VALID_SUBSCRIPTION;

    const subscriptionExpiring = user && user.subscription_status === EXPIRING;

    const subscriptionEndDate = user && user.subscription_period_end;

    const lastFourCardDigits = user && user.card_last_four_digits;

    return (
      <div className="premium-card-container">
        <h1>
          <strong>
            {i18n.t('account.PREMIUM')}
          </strong>
        </h1>
        {userCanUpdateOrCancel ? (
          <div>
            <div className="credit-card-container">
              <strong>
                <FontAwesome className="credit-card" name="credit-card" />
                <span>xxxx xxxx xxxx {lastFourCardDigits}</span>
              </strong>
            </div>
            <div>
              <div className="button-container update-card-information-container">
                <Button
                  onClick={ this.routeToUpdateCardScreen }
                  text={ i18n.t('account.UPDATE_CARD_INFORMATION') }
                />
              </div>
            </div>
            <div className="button-container  cancel-subscription-container">
              <Button
                onClick={ this.startSubscriptionCancel }
                text={ i18n.t('account.CANCEL_SUBSCRIPTION') }
              />
            </div>
          </div>
        ) : (
          ''
        )}
        {userCanBuyPremium ? (
          <div className="button-container sign-up-button-container">
            <Button
              onClick={ this.routeToPremiumScreen }
              text={ i18n.t('account.SIGN_UP_DEUCE_PREMIUM') }
            />
          </div>
        ) : (
          ''
        )}
        {subscriptionExpiring ? (
          <div>
            {i18n.t('payments.SUBSCRIPTION_CANCELLED')}
            {' '}
            <br />
            {i18n.t('payments.SUBSCRIPTION_EXPIRING')}
            {PremiumCardContainer.formatSubscriptionEndDate(
              subscriptionEndDate
            )}
            .
            {' '}
            {i18n.t('payments.CONTACT_DEUCE')}
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

PremiumCardContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.shape({
    stripe_subscription: PropTypes.number
  }),
  openModal: PropTypes.func.isRequired,
  getUserData: PropTypes.func.isRequired
};

PremiumCardContainer.defaultProps = {
  user: {
    stripe_subscription: null
  }
};

const mapStateToProps = state => ({
  user: state.auth.user
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  openModal: (modal, modalData) => dispatch(openModal(modal, modalData)),
  getUserData: () => dispatch(getUserData())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PremiumCardContainer);



// WEBPACK FOOTER //
// ./src/containers/PremiumCardContainer.js